import { render, staticRenderFns } from "./dashboard-resumo.vue?vue&type=template&id=21d118ff&scoped=true"
import script from "./dashboard-resumo.vue?vue&type=script&lang=js"
export * from "./dashboard-resumo.vue?vue&type=script&lang=js"
import style0 from "./dashboard-resumo.vue?vue&type=style&index=0&id=21d118ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d118ff",
  null
  
)

export default component.exports